import * as React from 'react';

import { FaqSection, IFaqItem } from 'shared/components/FaqSection';
import { useAccordion } from 'shared/hooks';

const FAQ_ITEMS: IFaqItem[] = [
  {
    question: 'Сколько стоят ваши услуги?',
    answer:
      'Поиск надежного риелтора, подключение максимального продвижения и поддержка команды — бесплатно. Оплатить нужно только услуги риелтора и только после успешного завершения сделки.',
  },
  {
    question: 'Откуда мне знать, что риелтор — и правда профессионал?',
    answer:
      'В Сделке работают только партнёрские агентства, за которые мы ручаемся: проверили лично, подобрали по рейтингу и отзывам, оценили опыт решения сложных кейсов',
  },
  {
    question: 'Что делать, если мне не понравится риелтор?',
    answer:
      'По любым вопросам вы сможете обратиться к нам, и мы подключимся, чтобы помочь и подобрать другого специалиста',
  },
  {
    question: 'Я смогу выбрать риелтора из вашего списка самостоятельно?',
    answer:
      'Нет, после консультации мы выберем для вас специалиста с самым подходящим опытом, который ориентируется в нужном районе. Если вдруг отношения с этим агентом у вас не сложатся — обратитесь к нам, и мы подберём другого.',
  },
  {
    question: 'С какой недвижимостью вы можете помочь?',
    answer: 'С любой жилой: квартирой — от застройщика и на вторичке, домом, дачей и даже участком.',
  },
];

export const FaqSectionContainer: React.FC = () => {
  const { toggle, isOpen } = useAccordion(0);

  return <FaqSection items={FAQ_ITEMS} isOpen={isOpen} onToggle={toggle} />;
};
